import { render, staticRenderFns } from "./CustomState.vue?vue&type=template&id=68d874c1"
import script from "./CustomState.vue?vue&type=script&lang=js"
export * from "./CustomState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports